import fixtureTypes from '../fixtureTypes'

const other = [
  {
    label: 'Smoke',
    value: fixtureTypes.SMOKE,
    models: [
      {
        value: ':/FIXTURES/OTHERS/FOG',
        label: 'Fog',
        asset: {
          src: 'Images/Icons/profilebuilder/3d/Others-Fog.png',
          class: 'pb-properties-details-model-selection-list-preview',
        },
      },
    ],
  },
]

export default other
